import React, { useEffect, useState } from 'react';
import { LandingCheckoutScope, LandingCheckoutStatusEnum, TemplateType } from '@dev/ee-api/ee-api-models';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { sendEventToGTM } from '@dev/ee-tools';
import { TemplateOpenFromGallery, TemplatePreviewFromGallery } from '@/store/checkoutCreator/actions';
import { ItemsGallery } from '@/components/ItemsGallery';
import { GetAllCheckoutsStart, getCheckoutsStore } from '@/store/checkouts/actions';
import { Container } from '@dev/ee-components';
import useMobile from '@/services/hooks/useMobile';
import { StdLoadListInterface } from '@/store/checkouts/types';

export const GalleryTemplateList = (): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isMobile = useMobile();
    const { loadingTemplates, templatesList, count } = useSelector(getCheckoutsStore);

    const [params, setParams] = useState<StdLoadListInterface>({
        loadingTemplates: true,
        page: 1,
        limit: 24,
        search: '',
        statusList: [LandingCheckoutStatusEnum.Published, LandingCheckoutStatusEnum.Draft],
        from: null,
        to: null,
        offset: 0,
        scope: LandingCheckoutScope.Public,
        isUrlUpdateDisabled: true
    });

    useEffect(() => {
        dispatch(GetAllCheckoutsStart(params));
    },[params])

    const editTemplateFromGallery = (templateName: string) => {
        const selectedCheckout = templatesList?.find((item) => item.ProductTemplateName === templateName);
        if (!selectedCheckout) {
            return;
        }
        sendEventToGTM("select_checkout_template", { templateName });
        dispatch(TemplateOpenFromGallery({ 
            productTemplateName: templateName,
            paymentTemplateName: selectedCheckout.CheckoutTemplateName,
            confirmationTemplateName: selectedCheckout.PaymentConfirmationTemplateName,
            isPublic: true
        }));
    };

    const templatePreviewStart = (templateName: string) => {
        dispatch(TemplatePreviewFromGallery(templateName, true, TemplateType.LandingPageProductTemplate));
    };

    const onPageChange = (page: number, perPage: number) => {
        setParams((state) => ({...state, page, limit: perPage }))
    };
    
    const onSearchChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        setParams((state) => ({...state, search: e.target.value, page: 1 }))
    };
    
    const onSearchDelete = () => {
        setParams((state) => ({...state, search: '' }))
    };

    return (
        <Container>
            <ItemsGallery
                isBusy={loadingTemplates}
                isMobile={isMobile}
                items={templatesList?.map((item) => ({ id: item.Name, name: item.Name, screenshot: item.ProductScreenshot }))}
                itemsTypeName={t('templates')}
                emptyMessage={t('notemplatestodisplay')}
                activePage={params.page}
                itemsPerPage={params.limit}
                itemsTotalCount={count}
                searchValue={params.search}
                searchPlaceholder={t('searchfortemplates')}
                onSearchChange={onSearchChange}
                onSearchDelete={onSearchDelete}
                onPageChange={onPageChange}
                onItemPreview={templatePreviewStart}
                onItemEdit={editTemplateFromGallery}
            />
        </Container>
    );
};
